import React, { useContext } from 'react'
import { Grid, Typography, Box, Chip, Alert, Autocomplete, Checkbox, TextField, CircularProgress } from '@mui/material'
import { WhatsApp } from '@mui/icons-material'
import { WhatsappDataContext } from '../WhatsappMessageContent'
import { Controller, useFormContext } from 'react-hook-form'

const TemplateSelection = () => {
    const {loading,templates, selectedTemplate, templateVariables,handleTemplateChange} = useContext(WhatsappDataContext)
    const { control,setValue} = useFormContext();

  return (
    <>
        <Grid item xs={12} sm={7}>
            <Typography gutterBottom sx={{ 
                fontWeight: 600, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                mb: 2,
                fontSize:'0.75rem'
            }}>
                <WhatsApp color="primary" />
                Configure WhatsApp Template
            </Typography>

            {/* Template Selection */}
            <Controller
                name='templateName'
                control={control}
                rules={{
                    required: 'Select a WhatsApp template',
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Autocomplete
                        size="small"
                        disableCloseOnSelect
                        options={templates}
                        value={ templates.find(t => t.name === value) || null }
                        loading={loading}
                        onChange={(event, newValue) => {
                            // let nValue = handleTemplateChange(event, newValue);
                            // setValue('languageCode', newValue ? newValue.language : '');
                            onChange(newValue ? newValue.name : '');
                            handleTemplateChange();
                        }}
                        getOptionLabel={(option) => {
                            return option.name || '';
                        }}
                        isOptionEqualToValue={(option, val) => option.name === val.name}
                        renderOption={(props, option, { selected }) => {
                            return (
                                <li {...props}>
                                    <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                                                {option.name}
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary' }}>
                                                {option.language} • {option.status}
                                            </Typography>
                                        </Box>
                                        {option.status === 'APPROVED' && (
                                            <Chip 
                                                label="Approved" 
                                                size="small" 
                                                color="success"
                                                sx={{ height: 20, fontSize: '0.65rem' }}
                                            />
                                        )}
                                    </Box>
                                </li>
                            );
                        }}
                        noOptionsText={<span style={{ fontSize: '0.75rem' }}>No Template found</span>}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                placeholder="Select template"
                                InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: '0.75rem', color: '#000' },
                                    endAdornment: (
                                        <>
                                            {loading && <CircularProgress size={16} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                )}
            />
        </Grid>
        <Grid item xs={12} sm={5}>
            {selectedTemplate && (
                <>                                            
                    {/* Template Info */}
                    <Alert severity="info" sx={{ mb: 2, fontSize: '0.75rem' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                            Template: {selectedTemplate.name}
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
                            Category: {selectedTemplate.category} | Language: {selectedTemplate.language}
                        </Typography>
                        {templateVariables.length > 0 && (
                            <Typography variant="body2" sx={{ fontSize: '0.7rem', mt: 0.5 }}>
                                This template requires {templateVariables.length} parameter(s)
                            </Typography>
                        )}
                    </Alert>
                </>
            )}
        </Grid>
    </>
  )
}

export default TemplateSelection
